<template>
  <SOSlotBase
    :bg-white="true"
    :container-name="'pengingat-masa-aktif'"
    :loading="pageSetting.loading"
  >
    <template v-slot:loading-page>
      <SOLoadingPage />
    </template>

    <template v-slot:title-bar>
      <SOTitleBar
        :page-title="'Ambil Tanpa Lunasi'"
        :type="'back'"
        @back="back"
      />
    </template>

    <template v-slot:content>
      <div class="p-x-20 p-y-12">
        <div class="f-regular f-14 f-c-black">
          Pelunasan transaksi yang dilakukan konsumen saat melakukan pengambilan
          barang di outlet.
        </div>
      </div>
      <div class="separator"></div>
      <star-rating></star-rating>
      <div class="p-x-20 p-y-20">
        <div
          @click.prevent.stop="
            validateAccess('takeWithoutPay.update') && requestChange()
          "
        >
          <SOInputOnOff
            :disabled="!validateAccess('takeWithoutPay.update')"
            class="m-d-20"
            :checkboxes="ambilTanpaPelunasan"
            :checked="formData.owner_pengaturan_umum.ambil_tanpa_lunasi > 0"
          />
        </div>
        <template v-if="formData.owner_pengaturan_umum.ambil_tanpa_lunasi > 0">
          <span class="f-14 f-c-midgrey">Pengaturan</span>
          <div
            @click="showPengaturanModal((hiddenOptions = false))"
            class="border rounded-lg p-2 d-flex justify-content-between align-items-center"
          >
            <div v-if="formData.owner_pengaturan_umum.ambil_tanpa_lunasi === 1">
              <div>Semua Konsumen</div>
              <span class="f-c-midgrey f-14">
                Diatur untuk {{ formData.count_all_customer }} konsumen
              </span>
            </div>
            <div
              v-else-if="
                formData.owner_pengaturan_umum.ambil_tanpa_lunasi === 2
              "
            >
              <div>Hanya Konsumen Tertentu</div>
            </div>
            <div>
              <i class="fas fa-chevron-down f-c-muted" />
            </div>
          </div>
        </template>
        <template
          v-if="formData.owner_pengaturan_umum.ambil_tanpa_lunasi === 2"
        >
          <div class="border-top my-3" />
          <div class="border rounded-lg p-2 d-flex justify-content-between">
            <div>
              <div
                v-for="(item, index) in formData.customer.slice(0, 5)"
                :key="index"
              >
                {{ item.nama }}
              </div>
              <span
                v-if="formData.customer.length > 5"
                class="f-c-midgrey f-14"
              >
                Serta {{ formData.customer.length - 5 }} konsumen lainnya...
              </span>
            </div>
            <div>
              <i
                @click="showPengaturanModal((hiddenOptions = true))"
                class="far fa-edit color-206CF"
                data-toggle="modal"
                data-target="#modalEname"
              />
            </div>
          </div>
        </template>
        <div class="f-regular f-12 m-t-16 f-c-midgrey m-d-4">
          <template
            v-if="formData.owner_pengaturan_umum.ambil_tanpa_lunasi > 0"
          >
            Konsumen yang dipilih <b> bisa </b> ambil semua barang tanpa
            melunasi transaksi.
          </template>
          <template v-else>
            Konsumen <b> tidak bisa </b> ambil semua barang tanpa melunasi
            transaksi.
          </template>
        </div>
      </div>
    </template>

    <template v-slot:modal>
      <AturKonsumenModal
        :loading="pageSetting.loading"
        ref="modalKonsumen"
        @setLoading="(v) => (pageSetting.loading = v)"
      />
      <ConfirmChangeModal
        :loading="pageSetting.loading"
        ref="confirmModal"
        @close="closeModal((confirmed = false))"
        @confirmChange="(v) => changeAmbilPelunasan(v)"
      />
    </template>
  </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "@/modules/pengaturan-umum/store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import AturKonsumenModal from "@/modules/pengaturan-umum/views/modal/AturKonsumenModal";
import ConfirmChangeModal from "@/modules/pengaturan-umum/views/modal/ConfirmChangeModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

export default {
  name: "AmbilTanpaPelunasan",
  components: {
    SOSlotBase,
    SOLoadingPage,
    SOTitleBar,
    SOInputOnOff,
    SOSlotCard,
    AturKonsumenModal,
    ConfirmChangeModal,
    SOInputSelect,
  },
  computed: {
    ...mapGetters("pengaturanUmumModule", {
      reminderInfo: "reminderInfo",
      reminderOption: "reminderOption",
      formData: "customerAmbilDanLunasi",
    }),
  },
  data() {
    return {
      ambilTanpaPelunasan: {
        name: "ambil-tanpa-pelunasan",
        data: [
          {
            id: "rem-1",
            value: "1",
            title: "Bisa ambil semua tanpa pelunasan",
            checked: false,
            titleBold: false,
          },
        ],
        options: [
          {
            id: 0,
            text: "Hanya Konsumen tertentu",
          },
          {
            id: 1,
            text: "Semua Konsumen",
          },
        ],
      },
      pageSetting: {
        loading: false,
        hiddenOptions: false,
        section: {
          deposit: false,
          epayment: false,
          isChekedTake: false,
        },
        modal: {
          konsumen: false,
          confirm: false,
          props: {
            getDataAction: "",
            submitAction: "",
            reminderId: "",
            reminderType: "",
            reminderAction: "",
            iddevice: "",
          },
        },
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    ...mapActions("pengaturanUmumModule", {
      getListOutlet: "getListOutlet",
      getAmbilPelunasanInfo: "getAmbilPelunasanInfo",
    }),
    ...mapActions({
      getListKonsumen: `${moduleName}/getListKonsumen`,
    }),
    back() {
      this.$router.push({ name: "pengaturanUmum.dashboard" });
    },
    async getInfo() {
      this.pageSetting.loading = true;
      await this.getAmbilPelunasanInfo();
      // this.formData = this.$store.state.pengaturanUmumModule.customerAmbilDanLunasi
      this.pageSetting.loading = false;

      setTimeout(() => {
        $(".card-body").addClass("card-body-no-footer");
      }, 100);
    },
    requestChange() {
      const status =
        this.formData.owner_pengaturan_umum.ambil_tanpa_lunasi > 0 ? 0 : 1;
      this.$refs.confirmModal.open(status);
    },
    showPengaturanModal(hiddenOptions) {
      if (!this.validateAccess("takeWithoutPay.update")) return;
      let obj = Object.assign({}, this.formData);
      this.$refs.modalKonsumen.open(hiddenOptions, obj);
    },
    async changeAmbilPelunasan(v) {
      this.pageSetting.loading = true;
      let value = v;
      let data = new FormData();
      data.append("type", value);
      let res = await this.$store.dispatch(
        "pengaturanUmumModule/updateAmbilPelunasan",
        data
      );
      if (res.success) {
        this.$toast.success("Pengaturan pelunasan traksaksi berhasil diupdate");
      } else {
        this.$toast.error(res.msg);
      }
      this.pageSetting.loading = false;
      this.$refs.confirmModal.close();
    },
    closeModal(confirmed) {
      if (confirmed) this.changeAmbilPelunasan();
      this.pageSetting.modal = {
        konsumen: false,
        confirm: false,
        props: {
          getDataAction: "",
          submitAction: "",
          reminderId: "",
          reminderTypfe: "",
          iddevice: "",
        },
      };
    },
  },
  beforeDestroy() {
    $(".card-body").removeClass("card-body-no-footer");
  },
};
</script>

<style>
.card-body-no-footer {
  border-bottom: none !important;
  padding-bottom: 0 !important;
}
</style>
